import React, { useEffect, useState } from 'react';
import Airtable from 'airtable';
import ClassCard from './ClassCard';
import './Schedule.css';


const base = new Airtable({ apiKey: 'patSC380Iqo0SiW2V.78552c6752df5d14f20b08dd2b27c6023da20b2c6c60ac07d81aa546984290ce' }).base('appud46PxsAoxoBru');

const Schedule = () => {
  const [schedules, setSchedules] = useState([]);
  const [error, setError] = useState(null);
  const tableName = process.env.REACT_APP_AIRTABLE_TABLE_NAME || 'Schedule for Math Classes copy';

  useEffect(() => {

    base(tableName).select({
      view: 'Grid view'
    }).firstPage((err, records) => {
      if (err) {
        console.error('Error fetching data:', err);
        setError(err);
        return;
      }
      console.log('Fetched data:', records);
      setSchedules(records.map(record => record.fields));
    });
  }, [tableName]);

  return (
    <div className="schedule">
      {error && <p>Error fetching data: {error.message}</p>}
      <div className="class-list">
        {schedules.map((schedule, index) => (
          <ClassCard key={index} classData={schedule} />
        ))}
      </div>
    </div>
  );
};

export default Schedule;